
import store from "../store";
import * as Cookies from "js-cookie";
import configR from '@/configs.js';
// 验证token是否有效
export function checkIfTokenValid(tokenExpiryDate){
  if(!tokenExpiryDate) {
    console.error('token有效期无值');
    return false;
  }
  let nowTime = (new Date()).getTime();
  return tokenExpiryDate * 1000 > nowTime;
}
// 随机数字
export function GetRandomNum(Min,Max)
{
  let Range = Max - Min;
  let Rand = Math.random();
  return(Min + Math.round(Rand * Range));
}
// 随机字符串
function GenerateMixed(n) {
  let str = ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'];
  let res = "";
  for(let i = 0; i < n ; i ++) {
    let id = Math.ceil(Math.random()*35);
    res += str[id];
  }
  return res;
}
// 登陆
export function login(){
  store.dispatch('signOut').then(()=>{
    Cookies.remove('isLogin')
  })
  // UniAuth认证
  let url;
  if(configR.envConfigs.LOGIN_WAY === 'uniAuth') {
    let uniAuthConfig = JSON.parse(configR.envConfigs.AUTH_SETTING);
    uniAuthConfig.state = GetRandomNum(1,999999);
    uniAuthConfig.nonce = GenerateMixed(6);
    store.commit('SET_UNIAITH_NONCE', uniAuthConfig.nonce);
    url = `${uniAuthConfig.url}idtoken/login?client_id=${uniAuthConfig.client_id}&redirect_uri=${configR.envConfigs.VUE_APP_URL}&state=${uniAuthConfig.state}&nonce=${uniAuthConfig.nonce}`
    if ("spa" === configR.envConfigs.ENTRY_MODE) {
      url = `${uniAuthConfig.url}idtoken/login?client_id=${uniAuthConfig.client_id}&redirect_uri=${configR.envConfigs.VUE_APP_SPA_URL}&state=${uniAuthConfig.state}&nonce=${uniAuthConfig.nonce}`
    }
  } else {
    // cas 认证
    url = configR.envConfigs.VUE_APP_CAS_URL + 'login?service=' + configR.envConfigs.VUE_APP_URL;
    if ("spa" === configR.envConfigs.ENTRY_MODE) {
      url = configR.envConfigs.VUE_APP_CAS_URL + 'login?service=' + configR.envConfigs.VUE_APP_SPA_URL;
    }
  }

  window.location.href = url;
}
// 退出
export function logout(){
  let url;
  if(configR.envConfigs.LOGIN_WAY === 'uniAuth') {
    let uniAuthConfig = JSON.parse(configR.envConfigs.AUTH_SETTING);
    url = `${uniAuthConfig.url}idtoken/logout?redirect_uri=${encodeURIComponent(configR.envConfigs.VUE_APP_URL)}`;
    if ("spa" === configR.envConfigs.ENTRY_MODE) {
      url = `${uniAuthConfig.url}idtoken/logout?redirect_uri=${encodeURIComponent(configR.envConfigs.APP_SPA_URL)}`;
    }
  } else {
    url = `${configR.envConfigs.VUE_APP_CAS_URL}logout?service=${configR.envConfigs.VUE_APP_URL}`;
    if ("spa" === configR.envConfigs.ENTRY_MODE) {
      url = `${configR.envConfigs.VUE_APP_CAS_URL}logout?service=${configR.envConfigs.APP_SPA_URL}`;
    }
  }
  store.dispatch('signOut').then(()=>{
    Cookies.remove('isLogin')
    window.location.href = url;
  })
}
export function getQueryString(name,url) {
  let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  if(url) {
    let searchIndex = url.indexOf('?');
    url = url.substr(searchIndex + 1)
  }
  let r = url ? url.match(reg) : window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}
export function formatTimestamp(value, target) {
  // if (isNaN(value)) return "未知";  不支持2020-04-14T08:45:17.000+0000格式 所以注释
  if (!value) return "";
  let date = new Date(value);
  let y = date.getFullYear(); // 1970 - ????
  let m = date.getMonth() + 1; // 0 - 11
  m = m < 10 ? "0" + m : m;
  let d = date.getDate(); // 1 - 31
  d = d < 10 ? "0" + d : d;
  let w = date.getDay(); // 0 - 6
  w = ["日", "一", "二", "三", "四", "五", "六"][w];
  let h = date.getHours();
  h = h < 10 ? "0" + h : h;
  let min = date.getMinutes();
  min = min < 10 ? "0" + min : min;
  let s = date.getSeconds();
  s = s < 10 ? "0" + s : s;
  // 指定目标
  switch (target) {
    case "yyyy": // 年
      return y;
    case "MM": // 月
      return m;
    case "dd": // 日
      return d;
    case "w": // 周
      return w;
    case "yyyy-MM":
      return `${y}-${m}`;
    case "yyyy年MM月":
      return `${y}年${m}月`;
    case "yyyy-MM-dd":
      return `${y}-${m}-${d}`;
    case "yyyy-MM-dd HH:mm":
      return `${y}-${m}-${d} ${h}:${min}`;
    case "yyyy-MM-dd HH:mm:ss":
      return `${y}-${m}-${d} ${h}:${min}:${s}`;
    case "HH:mm":
      return `${h}:${min}`;
    case "HH:mm:ss": //
      return `${h}:${min}:${s}`;
    default:
      return `${y}年${m}月${d}日 周${w}`;
  }
}
export function ifNewVisit(startTime,endTime,ternal){
  if(!startTime || !endTime || !ternal ) {
    return false;
  }
  let startStamp = new Date(startTime).getTime();
  if (endTime - startStamp <=  ternal) return true;
  return false;
}
// 获取导航白名单
export function getUserWhiteNavs(userNav){
  // userNav 元素倒叙 得到reverseArr；
  let reverseArr = [];
  userNav.forEach( item => {
    reverseArr.unshift(item);
  })
  // 混合权限控制的导航与公共导航
  let commonRouters = ["BusinessManagementCenter","SignIn","Tourist","AddNetworkAccount","Logout","ServiceCenter","NewsCenter", "NewsDetail",
    "HelpCenter","ContentReleaseRedHead","CreateApplication","CreateService", "EditApplication", "EditService", "ViewApplication",
    "ViewService","ShelfApplicationService","AddTerminal","ServiceInfo","ApplicationInfo","DataInfo",
    "DataView","DataShareMe","GlobalSearch","PersonalCenter","Information","SafeConfig","UnionLogin","LoginHistory","MyCollections","MyMessage",
    "MyCost","addressCard","Agent","MessagesCenter",'blankData', 'MailRegistry',"CardShow","SystemUpdating","Error"]
  reverseArr.forEach( item => {
    if(item.pageCode === 'Home') {
      item.pageCode = 'Index'
      // commonRouters.unshift('BusinessManagementCenter');
    }
    commonRouters.unshift(item.pageCode);
  })
  return commonRouters;
}
// 获取导航授权验证的白名单
export function getUserAuthedWhiteNavs(userNav){
  // userNav 元素倒叙 得到reverseArr；
  let authedWhiteNavs = [];
  userNav.forEach( item => {
    if(item.pageCode === 'Home') {
      item.pageCode = 'Index'
    }
    authedWhiteNavs.push(item.pageCode);
  })
  return authedWhiteNavs;
}
// 判断角色获取页面
export function getPageByUserRole(pageList){
  // 6 管理员 3 教师 4 学生 2 访客
  let roleSort  = ["6","3","4","2"]
  let sortedData = []
  roleSort.forEach( roleItem => {
    pageList.forEach(item => {
      let rightList = item.rightList;
      if(rightList.includes(roleItem)) {
        sortedData.push(item)
      }
    })
  })
  return sortedData[0]
}


